module.exports = __webpack_public_path__ + "static/media/sf-trial-3.384c83d0.mp3";